import type { ElementChildrenRendererProps } from './types';

const usePresenter = (props: ElementChildrenRendererProps): ElementChildrenRendererProps => {
  return props;
};

export default usePresenter;
